"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionDetail = void 0;

var React = _interopRequireWildcard(require("react"));

var _blocks = require("@bueno/blocks");

var Elements = _interopRequireWildcard(require("./ActionDetail.styles"));

const ActionDetail = ({
  label,
  description,
  targetNames
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Elements.SiteLabel, null, /*#__PURE__*/React.createElement(_blocks.SiteOutline, null), " ", label), /*#__PURE__*/React.createElement(Elements.Detail, null, /*#__PURE__*/React.createElement(Elements.StyledBodyLarge, null, /*#__PURE__*/React.createElement("strong", null, "Insight & Equipment")), /*#__PURE__*/React.createElement(Elements.StyledBodyLarge, null, description), targetNames.map(targetName => /*#__PURE__*/React.createElement(Elements.Chip, {
    key: targetName
  }, targetName))));
};

exports.ActionDetail = ActionDetail;